'use strict';

angular.module('controllers')
	.directive('loadMore', function () {
		var timer = null;
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				//var raw = elem[0];
                //var heightBody = angular.element(raw).height();

                //angular.element(document.querySelector('.table tbody')).css({height: 150 + 'px'});
                //angular.element(document.querySelector('tbody')).css({height: 150 + 'px'});
                //angular.element(raw).css({height: 150 + 'px'});
               // console.log(raw.scrollTop +'-'+ raw.offsetHeight +'-'+ raw.scrollHeight)
               // angular.element(raw).css({height: raw.scrollHeight-20 + 'px'});
				/*elem.bind('scroll', function () {
					clearTimeout(timer);
					timer = setTimeout(function () {
                        //console.log(heightBody)
                        console.log(raw.scrollTop +'-'+ raw.offsetHeight +'-'+ raw.scrollHeight)
                        //angular.element(raw).css({height: raw.scrollHeight-20 + 'px'});

						if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
							scope.$apply(attrs.loadMore);
						}
					}, 250);
				});*/
        if (angular.isUndefined(scope.last)) {
            scope.last = 0;
        }
        var fillElement = angular.element(document.querySelector(".fill-height"));
        fillElement.bind('scroll', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
                if(scope.state.itemsPerPage == 0 && scope.last == 0) {
                    if(elem[0].getAttribute('class') == 'tbody-slot'){
                        if (fillElement[0].scrollTop + fillElement[0].offsetHeight + 500 >= fillElement[0].scrollHeight) {
                            scope.$apply(attrs.loadMore);
                        }
                    } else {
                             //console.log(fillElement[0].scrollTop)
                            // console.log(elem[0].offsetHeight)
                            // console.log(fillElement[0].scrollHeight)
                        if (fillElement[0].scrollTop + fillElement[0].offsetHeight + 10 >= fillElement[0].scrollHeight) {
                            scope.$apply(attrs.loadMore);
                        }
                    }
                }
            }, 500);
        });



			}
		};
});
